// import 'https://cdnjs.cloudflare.com/ajax/libs/flowbite/2.3.0/flowbite.min.js';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { withInactivityTimeout } from './auth/SessionTimeout.jsx';
import { AllRoutes } from './contexts/AllRoutes.jsx';
import Layout from './components/Layout/index.jsx';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

function App() {
  const isActive = useSelector((state) => state.toggle.isActive);
  AOS.init({
    offset: 200,
    duration: 600,
    easing: 'ease-in-sine',
    delay: 100,
  });

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, [isActive]);

  useEffect(() => {
    AOS.refreshHard();
  }, [isActive]);

  return (
    <Router>
      <ToastContainer />
      <Layout>
        <div className="" key={isActive}>
          {AllRoutes()}
        </div>
      </Layout>
    </Router>
  );
}

export default withInactivityTimeout(App);